import { useTranslation } from "react-i18next"
import Alert from "../Alert"
import RichEditorComponent from "./RichEditorComponent"
import { useContext } from 'react'
import { ConfigContext } from '../ConfigProvider'

const RichEditor = (props) => {
    const { t } = useTranslation()
    const { uploadPolicy } = useContext(ConfigContext)
    return uploadPolicy
        ? <RichEditorComponent uploadPolicy={uploadPolicy} {...props} />
        : <Alert color="danger">{t(`Failed to load editor. Please refresh the page to try again.`)}</Alert>
}

export default RichEditor